export default {
  home: {
    title: 'Home',
    explanation: 'Back to homepage',
    tab1: 'Artl@s database',
    tab2: 'Data',
    tab3: 'Usage',
    tab4: 'Navigation',
    tab1_title1: 'Welcome to the BasArt!',
    tab1_par1: 'Artlas provides a global digital database of exhibition catalogues, encompassing all types of catalogues from the invention of the exhibition catalogue (Paris Salon, 1673) to the present day.',
    tab1_par2: 'This database is georeferenced and dated, allowing for the mapping of exhibitions, tracing the circulation of artworks, and tracking artists’ exhibitions. Additionally, when available, it links exhibited works to their locations, owners, the birthplace of their creators, and any other relevant information derived from the catalogues.',
    tab1_par3: 'Since 2019, the database has been maintained and expanded by the teams of the Digital Humanities Chair at the ',
    tab1_link0: 'University of Geneva',
    tab1_par3a: '. From 2011 to 2016 the construction of the database was funded by the French',
    tab1_link1: 'National Research Agency',
    tab1_par4: ' (ANR), through a Young Researchers project (2011-2016). Its development and maintenance until 2019 were made possible by the support of the ',
    tab1_link2: 'École normale supérieure',
    tab1_par5: ', the ',
    tab1_link3: 'Université de recherche Paris Sciences Lettres,',
    tab1_par6: ' and the ',
    tab1_link4: 'labex TransferS',
    tab1_par7: ' (École normale supérieure - Collège de France, Paris).',
    tab1_par8: 'The content of the database is contributed voluntarily by over a hundred active researchers from around the world. They generously offer their time and expertise to make georeferenced data, often difficult to access, available to everyone. The Artl@s database aims to broaden the horizons of art history, both from a sociological perspective (giving voice to the many) and a geographical one (bringing attention to the "peripheries").',
    tab1_title2: 'Direction of the project: Béatrice Joyeux-Prunel, University of Geneva, Switzerland, Digital Humanities Chair.',
    tab1_par9: 'In collaboration with Catherine Dossin (Purdue university) and Nicola Carboni (university of Illinois).',
    tab1_par10: 'Structure of the database:',
    tab1_par11: 'Interface:',
    tab2_title1: 'What is in the database?',
    tab2_par1: 'Since 2023, our collection has focused on catalogues from Swiss exhibitions, following an earlier effort centered on Biennales. These sources are intended to challenge the long-standing monocentric and bilateral geopolitics that have dominated 19th- and 20th-century art history (Paris-New York). The database also aims to enable a comprehensive study of collecting practices, women\'s representation, the evolution of artistic themes and forms, the institutionalization of modern and contemporary art, the history of the art market, political aspects of biennales, and the dynamics between centers and peripheries in the global history of contemporary art.',
    tab2_par2: 'The database should also allow us to study on a global scale questions of collecting, the presence of the women, the evolution of subjects matters and styles, the institutionalization of modern and contemporary art, the history of the art market, the politics at work in Biennials, etc. … as well as questions of centers and peripheries in the global history of living art.',
    tab2_title2: 'Sources',
    tab2_par3: 'BasArt is a collaborative project that continues to grow as researchers add new exhibitions and catalogues.',
    tab2_par4: 'The information in the database is entered with strict adherence to the original catalogues. For example, if the catalogue does not provide the birth date of the exhibitors, this information will not be added by Artl@s contributors. Additionally, the name of an artist may appear in different forms depending on the exhibition, such as "Matisse (Henri)" or "Henri-Matisse." Searches within the Artl@s database must account for this margin of variability.',
    tab2_par5: 'BasArt can only provide a comprehensive view when a query or visualization is based on complete collections, meaning full catalogues, with a clear understanding of the number and identity of the catalogues included. Indeed, many of the exhibitions listed in the database are not yet linked to a catalogue that details the exhibitors—this may be because the catalogue does not exist, has not been found, or has not yet been entered into the database.',
    tab3_title1: 'Terms of use',
    tab3_par1: 'The database is generously made available to the public by its authors, whatever the use of the data.',
    tab3_par2: 'Similarly, the maps and graphics made using the collections of the Artl@s database are freely provided to the users.',
    tab3_par3: 'The user agrees to cite the project and its contributors for each use.',
    tab3_title2: 'Citation',
    tab3_par4: 'The citation terms are as follows:',
    tab3_par5: 'For a catalog and its content:',
    tab3_par6: 'Exhibition and catalog filled in by ... [name of the contributor]. BasArt, The Art@s Project, dir. Béatrice Joyeux-Prunel, university of Geneva, Switzerland.',
    tab3_par7: 'for a map or a graphic:',
    tab3_par8: '© BasArt, The Artl@s Project, dir. Béatrice Joyeux-Prunel, university of Geneva, Switzerland.',
    tab3_par9: 'The ARTL@S project is not responsible for the ways users will use the data or the conclusions they will draw from it.',
    tab4_par1: 'The query interface allows you to search information pertaining to exhibitions, as well as any information that has been found and copied from these exhibition catalogs. In order to ensure optimal use, the interface allows you to search the list of exhibitions on the one hand, and the contents of each catalogs in the list on the other hand, for three types of objects in total: the exhibitions, and (according to the catalogs) the exhibitors and the exhibited works.',
    tab4_title1: 'The simple query',
    tab4_par2: 'allows users to browse through exhibitions, exhibitors, or exhibited works, with the option of limiting the search to certain exhibition collections, such as the biennials contained in the database.',
    tab4_title2: 'The advanced query',
    tab4_par3: 'gives the possibility to cross multiple searches on the exhibitions, the exhibitors',
    tab4_par4: 'and/or',
    tab4_par5: 'the exhibited works.',
    tab4_title3: 'Display of results',
    tab4_par6: 'Users can display the search results according to',
    tab4_par7: 'three types of visualization',
    tab4_par8: 'A list',
    tab4_par9: ', on the left, the content of which can be sorted by date, city of exhibition, and title.',
    tab4_par10: 'A map',
    tab4_par11: ', chronologically adjustable thanks to a timeline at the bottom right.',
    tab4_par12: 'Clicking on the city pop-up windows allows you get detailed the results for the query.',
    tab4_par13: 'A graphic',
    tab4_par14: 'quantitative and temporal that appears when clicking on the right button.'
  },
  results: {
    search: 'Search',
    of: 'of',
    in: 'in',
    list: 'List',
    map: 'Map',
    graph: 'Graph',
    exportCsv: 'CSV Export',
    firstname: 'Firstname',
    year: 'Year',
    title: 'Title',
    titleUnknown: '[unknown title]',
    city: 'City',
    unknown: 'Unknown',
    exhibition: 'Exhibition',
    exhibitionTitle: 'Exhibition title',
    exhibitionYear: 'Exhibition year',
    exhibitionCity: 'Exhibition city',
    exhibitedWorkTitle: 'Exhibited work title',
    gender: 'Gender',
    biography: 'Biography',
    nationality: 'Nationality',
    birth: 'Birth',
    birthSpace: 'Birth\'s space',
    birthDate: 'Date of birth',
    death: 'Death',
    deathSpace: 'Space of death',
    deathDate: 'Date of death',
    catalogDates: 'Dates of catalog',
    catalogUnknown: 'Catalog not set',
    address: 'Address',
    notes: 'Notes',
    exhibitedSpace: 'Exhibited space',
    exhibitedWork: 'Exhibited work',
    exhibitedWorks: 'Exhibited works',
    category: 'Category',
    section: 'Section',
    sectionTitle: 'Section title',
    sectionAddress: 'Section address',
    noSection: 'Section title not set',
    creationDate: 'Creation date',
    creationDate2: 'Creation date2',
    creationSpace: 'Creation space',
    contributorUnknown: '[Contributor unknown].',
    size: 'Size',
    medium: 'Medium',
    room: 'Room',
    credits: '© Artl@s, Ecole normale supérieure-PSL and Université de Genève, under direction of Béatrice Joyeux-Prunel.',
    filledBy: 'Contributor',
    sources: 'Sources',
    sourceExhibition: 'Exhibition source',
    owner: 'Owner',
    exhibitedWorkNotReproduceInCatalog: 'Exhibited work not reproduced in catalog',
    exhibitedWorkReproducedInCatalog: 'Exhibited work reproduced in catalog.',
    price: 'Price',
    exhibitors: 'Exhibitors',
    catalogTitle: 'Title, city, edition\'s year of catalog',
    publicationDate: 'Publication date',
    title_lower: 'Exhibition or catalog title',
    begin_year: 'Exhibition first year',
    end_year: 'Exhibition last year',
    country: 'Current country',
    former_country: 'Former country',
    city_lower: 'City',
    traveling: 'Itinerancy',
    source_catalog_lower: 'Catalog source',
    catalog_language_lower: 'Catalog language',
    contributor_lower: 'Catalog authors / contributors',
    notes_lower: 'Contributor\'s notes of Artl@s base',
    name: 'Name',
    name_lower: 'Name',
    nameMissing: 'Missing name',
    first_name: 'Firstname',
    first_name_lower: 'Firstname',
    name_firstname: 'Name, Firstname',
    nationality_lower: 'Nationality',
    city_b_lower: 'Birth city',
    country_b: 'Birth country',
    year_b: 'Birth date',
    year_d: 'Death date',
    exhibitor_name: 'Artist name',
    exhibitor_name_lower: 'Artist name',
    exhibitor_first_name: 'Artist firstname',
    exhibitor_first_name_lower: 'Artist firstname',
    year_c1: 'Conception year',
    year_c2: 'Conception year (end)',
    city_c_lower: 'Conception city',
    country_c: 'Former country',
    is_reproduced_in_catalog: 'Reproduced in catalog',
    space_lower: 'Exhibition space',
    owner_lower: 'Owner',
    city_o_lower: 'Owner\'s city',
    country_o: 'Country\'s owner',
    source: 'Source',
    x: 'Coord X',
    y: 'Coord Y',
    nb_exhibition_catalog: '',
    public: 'Public',
    exhibition_group: 'Exhibition group',
    exhibition_group_type: 'Group type',
    contributor: 'Contributor',
    membership: 'Membership',
    instructor: 'Instructor',
    birth_address: 'Birth address',
    exhibition_title: 'Exhibition title',
    exhibition_title_lower: 'Exhibition title',
    exhibition_city: 'Exhibition city',
    exhibition_city_lower: 'Exhibition city',
    begin_date: 'Begin date',
    end_date: 'End date',
    section_x: 'Section\'s Coord X',
    section_y: 'Section\'s Coord Y',
    death_address: 'Death address',
    country_d: 'Death country',
    number: 'Catalog number',
    translation_title: 'Translation title',
    subtitle: 'Sub title',
    section_title: 'Section title',
    section_link: 'Open section detail',
    section_address: 'Section address',
    space: 'Space',
    catalog_chapter: 'Catalog chapter'
  },
  chart: {
    export: 'Export',
    partResults: 'partial result',
    periodResults: 'Period\'s results',
    exhibitionTitles: 'exhibitions titles ',
    ofType: 'of type ',
    includes: 'includes "{value}"',
    allExhibition: 'all expositions',
    exhibitedWorkWith: 'exhibited works titles includes "{value}"',
    allExhibitedWorks: 'all exhibited works',
    exhibitorsNameWith: 'exhibitors name includes "{value}"',
    allExhibitors: 'all exhibitors',
    exhibitions: ' exhibitions',
    exhibitors: ' exhibitors',
    exhibitedWorks: ' exhibited works',
    title: 'Results by year',
    advancedSearch: 'Advanced search',
    feltingPoints: 'Not enough points to display a chart.',
    extendSearch: 'Please extend search period.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en_GB/pages.js